<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption"
                       :data="tableData"
                       :table-loading="tableLoading"
                       :page="page"
                       ref="crud"
                       @search-change="searchChange"
                       @refresh-change="refreshChange"
                       @row-save="handleSave"
                       @row-update="handleUpdate"
                       @size-change="pageSizeChange"
                       @current-change="pageChange">
                <template slot-scope="scope" slot="menuLeft">
                    <el-button type="primary"
                               icon="el-icon-plus"
                               size="small"
                               plain
                               @click.stop="handleAdd()"
                    >申请退货
                    </el-button>

                </template>
                <template slot-scope="scope" slot="status">
                    <el-tag v-for="obj of distributionSheetStatus" :key="obj.value" v-if="obj.value == scope.row.status">
                        {{obj.label}}
                    </el-tag>
                </template>
            </avue-crud>
            <template>
                <el-dialog title="二维码支付" :visible.sync="QRCodeDialog" align="center">
                    <vue-qr :text="config.value" :size="200"></vue-qr>
                    <el-button @click="QRCodeDialog = false">关闭</el-button>
                </el-dialog>
            </template>
            <el-dialog
                    title="申请退货"
                    :visible.sync="dialogVisible"
                    width="50%" :data="dialog" style="background-color: #4E5465">
                <el-row :gutter="20" style="margin: 10px;width: 50%;"  >
                    <span style="font-weight:bold">联系人:</span>
                    <el-input placeholder="请输入联系人"  style="margin: 22px;width: 50%;">
                    </el-input>
                </el-row>
                <el-row :gutter="20" style="margin: 10px;width: 50%;"  >
                    <span style="font-weight:bold">联系电话:</span>
                    <el-input placeholder="请输入联系电话"  style="margin: 10px;width: 50%;" >
                    </el-input>
                </el-row>
                <el-row :gutter="20" style="margin: 10px;width: 50%;"  >
                    <span style="font-weight:bold">取货地址:</span>
                    <el-input placeholder="请输入取货地址"  style="margin: 10px;width: 77%;" >
                    </el-input>
                </el-row>

                <el-row :gutter="20" style="margin: 10px;width: 50%;"  >
                    <span style="font-weight:bold">填写退货清单:</span>
                </el-row>
                <el-row :gutter="20" style="margin: 10px;width: 50%;"  >
                    进货单号:
                    <el-input v-model="dialog.supplyListNum" placeholder="请输入进货单号"  style="margin: 10px;width: 60%;" >
                    </el-input>
                <el-button type="primary"   @click.stop="findGoodsList(dialog)">查询</el-button>
                </el-row>
                <el-row :gutter="20" style="margin: 10px"  >
                    <span class="line" style="display: inline-block;width: 100%;border-top: 2px solid #cccccc ;"></span>
                </el-row>
                <el-row :gutter="20" style="margin: 10px"  >
                    <el-table
                            :data="tableData"
                            border>
                        <el-table-column
                                prop="secondClassifyName"
                                align="center"
                                label="商品种类" >

                        </el-table-column>
                        <el-table-column
                                prop="goodsName"
                                align="center"
                                label="商品名称">
                            

                        </el-table-column>
                        <el-table-column
                                prop="brand"
                                align="center"
                                label="商品品牌">
                            <template slot-scope="scope">
                                {{scope.row.brandName}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="goodsNum"
                                align="center"
                                label="数量">
                            <template slot-scope="scope">
                                {{scope.row.goodsNum}}
                            </template>

                        </el-table-column>
                        <el-table-column
                                prop="price"
                                align="center"
                                label="单价">
                            <template slot-scope="scope">
                                {{scope.row.merchantPrice}}
                                <!--<el-input type="input" name="price" :value="scope.row.merchantPrice" disabled="disabled" ></el-input>-->
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-col :span="24" style="text-align: center;font-size: 16px;font-weight:bold;margin: 10px">总计: {{dialog.totalPrice}}元</el-col>
                </el-row>
                <el-row :gutter="20" style="margin: 10px"  >
                    <span class="line" style="display: inline-block;width: 100%;border-top: 2px solid #cccccc ;"></span>
                </el-row>
                <el-row :gutter="20" style="margin: 10px"  >
                   <span style="font-weight:bold">填写退货物品数量:</span>
                </el-row>
                <el-row :gutter="20" style="margin: 10px"  >
                    <el-table
                            :data="tableData"
                            border>
                        <el-table-column
                                prop="secondClassifyName"
                                align="center"
                                label="商品种类">
                            <template slot-scope="scope">
                                {{scope.row.secondClassifyName}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                align="center"
                                label="商品名称">
                            <template slot-scope="scope">
                                {{scope.row.goods.name}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="brand"
                                align="center"
                                label="商品品牌">
                            <template slot-scope="scope">
                                {{scope.row.brandName}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="goodsNum"
                                align="center"
                                label="数量">
                            <template slot-scope="scope">
                                {{scope.row.goodsNum}}
                            </template>

                        </el-table-column>
                        <el-table-column
                                prop="price"
                                align="center"
                                label="单价">
                            <template slot-scope="scope">
                                {{scope.row.merchantPrice}}
                                <!--<el-input type="input" name="price" :value="scope.row.merchantPrice" disabled="disabled" ></el-input>-->
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-col :span="24" style="text-align: center;font-size: 16px;font-weight:bold;margin: 10px">总计: {{dialog.totalPrice}}元</el-col>
                </el-row>
                <el-row :gutter="20" style="margin: 10px;width: 95%;"  >
                    <span style="font-weight:bold">备注:</span>
                    <el-input placeholder="请输入备注"  style="margin: 10px;width: 50%;" >
                    </el-input>
                </el-row>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary"  @click.stop="handleReceipt(dialog)">提交</el-button>
              </span>
            </el-dialog>
        </basic-container>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {returnOrderOption} from "@/const/salesCloud/returnOrderOption";
    import {findReturnOrderList,findGoodsList} from "@/api/salesCloud/returnOrder"
    // import {findByLabel} from "@/util/util"
    import {DIC} from "@/const/dic"
    import VueQr from 'vue-qr'
    export default {
        name: "returnOrder",
        components: {
            VueQr
        },
        data() {
            return {
                tableOption: returnOrderOption, //表格设置属性
                tableData: [], //表格的数据
                tablePage: 1,
                tableLoading: false,
                dialogVisible:false,
                tabelObj: {},
                page: {
                    total: 0, //总页数
                    currentPage: 1, //当前页数
                    pageSize: 10 //每页显示多少条
                },
                grade: {
                    box: false,
                    check: []
                },
                distributionSheetStatus:DIC.DISTRIBUTION_SHEET_STATUS,
                QRCodeDialog:false,
                config:{},
                dialog:{}
            };
        },
        created() {
            this.handleList();

        },
        watch: {},
        mounted() {
        },
        computed: {
            ...mapGetters(["permission"])
        },
        props: [],
        methods: {
            pageSizeChange(pageSize) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = this.page.currentPage,
                    params.size = pageSize
                findReturnOrderList(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: this.page.currentPage,
                        pageSize: pageSize
                    };
                    this.tableLoading = false;
                })
            },
            pageChange(page) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = page
                params.size = this.page.pageSize
                findReturnOrderList(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: page,
                        pageSize: this.page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            searchChange(params) {
                this.tableLoading = true;
                // let params = this.$refs.crud.searchForm
                params.page = this.page.currentPage
                params.size = this.page.pageSize
                findReturnOrderList(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: params.page,
                        pageSize: params.size
                    };
                    this.tableLoading = false;
                })
            },
            refreshChange(page) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = page.currentPage
                params.size = page.pageSize
                findReturnOrderList(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: page.currentPage,
                        pageSize: page.pageSize
                    };
                    this.tableLoading = false;
                })
            },

            handleDetail(row, index){

            },
            /**
             * @title 打开新增窗口
             * @detail 调用crud的handleadd方法即可
             *
             **/
            handleAdd() {

                this.dialogVisible=true;
            },
            handleEdit(row, index) {

            },
            /**
             * @title 获取数据
             * @detail 赋值为tableData表格即可
             *
             **/
            handleList() {
                this.tableLoading = true;
                let parmas = {
                    page: this.page.currentPage,
                    size: this.page.pageSize
                }
                findReturnOrderList(parmas).then((res) => {
                    let data = JSON.parse(res.data);
                    console.log("集合："+JSON.stringify( data.rows))
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: this.page.currentPage,
                        pageSize: this.page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            /**
             * @title 数据添加
             * @param row 为当前的数据
             * @param done 为表单关闭函数
             *
             **/
            handleSave(row, done) {

            },

            /**
             * @title 数据更新
             * @param row 为当前的数据
             * @param index 为当前更新数据的行数
             * @param done 为表单关闭函数
             *
             **/
            handleUpdate(row, index, done) {

            },
            /**
             * 确认供货单
             * @param id
             */
            findGoodsList(dialog){
                let tableData= [{

                    goodsName: '王小虎',

                }]
                findGoodsList(dialog.supplyListNum).then((res) => {
                    //let data = JSON.parse(res.data);
                    if (res.code == '200') {
                        let goodsList=[];
                        let data = JSON.parse(res.data);
                        let obj=   data.rows[0].goodsList;

                        for(let goods of obj){
                                    let list={};
                                    list.discount=goods.discount;
                                    list.goodsNum=goods.goodsNum;
                                    list.supplyListGoodsId=goods.id;
                                    list.secondClassifyName=goods.secondClassifyName;
                                    list.brandName=goods.brandName;
                                    list.merchantPrice=goods.merchantPrice;
                                    list.goodsName=goods.goodsName;
                                    list.goods=goods;
                            console.log("数据："+JSON.stringify(list))
                                    goodsList.push(list);
                        }
                        dialog.goodsList=goodsList;

                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: "error"
                        })
                    }

                })
            },

            immediatePayment(id){

            }
        }
    };
</script>

<style lang="scss">
    .table-container {
        padding: 8px 10px;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>
